<!-- <div class="row">
    <div class="card" style="border-color: aliceblue !important;">
       <div class="card-body">
          <div class="d-grid gap-2 d-flex">
             <button class="btn btn-primary" (click)="this.selectedTab=0" [class.active]="selectedTab==0"
             type="button">{{user}} Details</button>
             <button class="btn btn-primary" (click)="this.selectedTab=1" [class.active]="selectedTab==1" type="button">KYC
             Documents</button> 
             <button class="btn btn-primary" (click)="this.selectedTab=2" [class.active]="selectedTab==2" type="button">Screening Report</button>
          </div>
       </div>
    </div>
</div> -->
<div class="row">
 <div class="card" [ngStyle]="{ 'display': selectedTab==0 ? 'block' : 'none' }">
       <label class="col-form-label" style="font-weight: bolder; font-size: x-large;">{{user}}
       Details </label>
       <div class="card-body">
          <div class="row">
             <div class="col-sm-4">
                <label class="col-form-label" for="fullName">{{user}} Name </label>
                   <input class="form-control" id="fullName" readonly type="text" [(ngModel)]="fname" name="fname">
             </div>
             <div class="col-sm-4">
                <label class="col-form-label" for="mobile">{{user}} Wallet Number </label>
                   <input class="form-control" id="mobile" readonly type="text" [(ngModel)]="mobile" name="mobile">
             </div>
             <div class="col-sm-4">
                <label class="col-form-label" for="emailId">{{user}} Email Id </label>
                   <input class="form-control" readonly id="emailId" [(ngModel)]="emailId" autocomplete="new-password"
                   type="text" name="emailId">
             </div>
          </div>
          <br>
          <div class="row">
             <div class="col-sm-4">
                <label class="col-form-label" for="eid">Emirates ID
                </label>
                      <input class="form-control" id="eid" [(ngModel)]="eid" readonly type="text" autocomplete="new-password"
                      name="eid">
             </div>
             <div class="col-sm-4">
                <label class="col-form-label" for="emiratesExpiry">Emirates Expiry Date</label>
                   <input class="form-control" readonly id="emiratesExpiry" type="text" autocomplete="new-password"
                   [(ngModel)]="emiratesExpiry" name="emiratesExpiry">
             </div>
             <div class="col-sm-4">
                <label class="col-form-label" for="edcMobile">Registered Contact Number</label>
                   <input class="form-control" readonly id="edcMobile" type="text" autocomplete="new-password"
                   [(ngModel)]="edcMobile" name="edcMobile">
             </div>
          </div>
          <br>
          <div class="row">
             <div class="col-sm-4">
                <label class="col-form-label" for="nationality">Nationality</label>
                   <input class="form-control" readonly id="nationality" type="text" autocomplete="new-password"
                   [(ngModel)]="nationality" name="nationality">
             </div>
             <div class="col-sm-4">
                <label class="col-form-label" for="dob">Date of Birth</label>
                   <input class="form-control" readonly id="personName" type="text" autocomplete="new-password"
                   [(ngModel)]="dob" name="dob">
             </div>
             <div class="col-sm-4">
                <label class="col-form-label" for="gender">Gender</label>
                   <input class="form-control" readonly [(ngModel)]="gender" name="gender" id="gender" type="text"
                   autocomplete="new-password">
             </div>
          </div>
          <br>
          <div class="row">
             <div class="col-sm-4">
                <label class="col-form-label" for="passportNumber">Passport Number</label>
                   <input class="form-control" readonly [(ngModel)]="passportNumber" name="passportNumber"
                   id="passportNumber" type="text" autocomplete="new-password">
             </div>
             <!-- <div class="col-sm-4">
                <label class="col-form-label" for="passportType">Passport Type</label>
                <div class="col-sm-9">
                   <input class="form-control" readonly [(ngModel)]="passportType" name="passportType" id="passportType"
                   type="text" autocomplete="new-password">
                </div>
             </div> -->
             <div class="col-sm-4">
                <label class="col-form-label" for="passportExpiry">Passport Expiry Date</label>
                   <input class="form-control" readonly [(ngModel)]="passportExpiry" name="passportExpiry"
                   id="passportExpiry" type="text" autocomplete="new-password">
             </div>
             <div class="col-sm-4">
              <label class="col-form-label" for="occupation">Occupation </label>
                 <input class="form-control" readonly [(ngModel)]="occupation" name="occupation" id="occupation"
                 type="text" autocomplete="new-password">
           </div>
          </div>
          <br>
          <div class="row">
             <div class="col-sm-4">
                <label class="col-form-label" for="pob">Place of Birth</label>
                   <input class="form-control" readonly [(ngModel)]="pob" name="pob" id="pob" type="text"
                   autocomplete="new-password">
             </div>
             <div class="col-sm-4">
              <label class="col-form-label" for="areaDesc">Address</label>
                 <input class="form-control" readonly [(ngModel)]="areaDesc" name="areaDesc" id="areaDesc" type="text"
                 autocomplete="new-password">
           </div>
             <!-- <div class="col-sm-4">
                <label class="col-form-label" for="emirate">Emirate</label>
                <div class="col-sm-9">
                   <input class="form-control" readonly [(ngModel)]="emirate" name="emirate" id="emirate" type="text"
                   autocomplete="new-password">
                </div>
             </div> -->
          </div>
          <!-- <br> -->
          <!-- <div class="row"> -->
             <!-- <div class="col-sm-4">
                <label class="col-form-label" for="poBox">P. O. Box </label>
                <div class="col-sm-9">
                   <input class="form-control" readonly [(ngModel)]="poBox" name="poBox" id="poBox" type="text"
                   autocomplete="new-password">
                </div>
             </div> -->
             <!-- <div class="col-sm-4">
                <label class="col-form-label" for="city">City</label>
                <div class="col-sm-9">
                   <input class="form-control" readonly [(ngModel)]="city" name="city" id="city" type="text"
                   autocomplete="new-password">
                </div>
             </div> -->
          <!-- </div> -->
       </div>
 </div>
 <div class="card" [ngStyle]="{ 'display': selectedTab==1 ? 'block' : 'none' }">
       <label class="col-form-label" style="font-weight: bolder; font-size: x-large; text-align-last: center;"> KYC Documents </label>
       <div class="card-body">
          <!--For Notification Highliter-->
          <div class="row">
             <div *ngIf="status===1" class="text-lg-center">
                <ngb-alert [dismissible]="false" [type]="'success'"><i class="feather icon-thumbs-up"></i>{{"Kyc is
                approved" |
                uppercase}}</ngb-alert>
             </div>
             <div *ngIf="status===2" class="text-lg-center">
                <ngb-alert [dismissible]="false" [type]="'danger'"><i class="feather icon-thumbs-down"></i> {{"Kyc is
                rejected"
                |
                uppercase}}</ngb-alert>
             </div>
          </div>
          <div class="row">
             <div class="card">
                <div class="card-body">
                   <h6 class="card-title">KYC Document List</h6>
                   <!-- <div class="row">
                      <div class="col-sm-12 align-middle">
                         <h5 class="card-title">1. Screening Report</h5>
                      </div>
                      <div class="col-sm-12" [innerHTML]="screeningReportPdf">
                      </div>
                   </div> -->
                   <br/>
                   <div class="row">
                      <div class="col-sm-12 align-middle">
                         <h5 class="card-title">1. Emirates ID</h5>
                      </div>
                      <div class="col-sm-12">
                         <img height="300px" [src]="emiratesIdImage">
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <!-- <div class="row g-3" style="margin-top: 30px;">
             <div class="col">
                <input type="text" class="form-control" placeholder="Remarks" aria-label="Remarks">
             </div>
             <div class="col">
                <button class="btn btn-success"><i class="feather icon-list"></i> Add Remarks</button>
             </div>
          </div> -->
          <!-- <div class="row" style="margin-top: 30px;">
             <div class="col-12">
                <button (click)="approve()" class="btn btn-success"><i class="feather icon-thumbs-up"></i> Approve</button>
                <button (click)="reject()" class="btn btn-danger"><i class="feather icon-thumbs-down"></i> Reject</button>
             </div>
          </div> -->
          <!--  approval section-->
          <!-- <div class="row"  style="margin-top: 30px;">
             <div class="col-md-12 stretch-card">
                <div class="card">
                   <div class="card-body">
                      <h6 class="card-title">KYC Remark List</h6>
                      <div class="table-responsive">
                         <button type="button" (click)="exportexcel()" class="btn btn-light">Export CSV<i  class="feather icon-download"></i></button> 
                         <table id="dataTableExample" class="table">
                            <thead>
                               <tr>
                                  <th>Serial No</th>
                                  <th>Application Status</th>
                                  <th style="min-width:50px;">Application Remarks</th>
                                  <th>Added By</th>
                                  <th>Added On</th>
                               </tr>
                            </thead>
                            <tbody>
                               <td style="text-align: center;padding: 20px;" colspan="4" [style.display]="!this.remarkData || this.remarkData.length==0 ? 'block' : 'none'">No Data Found</td>
                            </tbody>
                            <tfoot>
                               <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                               </tr>
                            </tfoot>
                         </table>
                      </div>
                   </div>
                </div>
             </div>
          </div> -->
       </div>
 </div>
 <div class="card mb-4" [ngStyle]="{ 'display': selectedTab==2 ? 'block' : 'none' }">
       <ul id="tabMenu" class="nav nav-tabs">
          <li class="nav-item">
             <a class="nav-link" [class.active]="activeTab === 'customerProfile'" (click)="switchTab('customerProfile')">Profile</a>
          </li>
          <li class="nav-item">
             <a class="nav-link" [class.active]="activeTab === 'nameScreening'" (click)="switchTab('nameScreening')">Name Screening</a>
          </li>
          <li class="nav-item">
             <a class="nav-link" [class.active]="activeTab === 'riskRating'" (click)="switchTab('riskRating')">Risk Rating</a>
          </li>
          <li class="nav-item">
             <a class="nav-link" [class.active]="activeTab === 'activityTimeline'" (click)="switchTab('activityTimeline')">Audit Trail</a>
          </li>
       </ul>
    <div class="row">
     <div class="col-9 mt-3">
     <h3 *ngIf="activeTab === 'customerProfile'">Profile</h3>
       <h3 *ngIf="activeTab === 'nameScreening'">Name Screening</h3>
       <h3 *ngIf="activeTab === 'riskRating'">KYC Risk Rating</h3>
       <h3 *ngIf="activeTab === 'activityTimeline'">Audit Trail</h3>
       </div>
       <!-- <div class="col-3 mt-3">
        <a class="text-decoration-underline" (click)="showInitiatePop(cont)" *ngIf="isInitiateKycFlag">Initiate Review</a>&nbsp;
        <a class="text-decoration-underline" (click)="showKycPop(kycCont)" *ngIf="isSubmittedKycFlag">Submit Review</a>
     </div> -->
     <div class="text-right">
      <button class="btn bg-danger-custom" (click)="downloadScreeningReport()">Download  <span class="feather icon-download"></span></button>
      <button class="btn bg-danger-custom" (click)="viewScreeningReport()">View  <span class="feather icon-eye"></span></button>
    </div>
    <div class="card mt-2">
       <div class="tab-content">
          <div id="customerProfile" class="tab-pane fade" [class.show]="activeTab === 'customerProfile'">
             <div class="container-fluid rounded bg-white mt-5 mb-5">
                <div class="row">
                   <div class="col-md-3 border-right">
                      <!-- <div class="d-flex flex-column align-items-center text-center p-3 py-5"><img class="rounded-circle mt-5" width="150px" src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"><span class="font-weight-bold"></span><span> </span></div> -->
                     <div [class]="merchantEnableClass" (click)="merchantSelect()">
                        <div class="contact-info">
                            <h3>{{merchantFullName}}</h3>
                            <p>Merchant</p>
                        </div>
                        <span *ngIf="merchantEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                    </div>
                        <div [class]="ubo.uboEnableClass" *ngFor="let ubo of UBOList;let i = index" (click)="selectUBOTab(ubo,i)">
                           <div class="contact-info">
                               <h3>{{ubo.shareHolderName}}</h3>
                               <p>Type of Shareholder : {{ubo?.typeOfShareHolder}}</p>
                           </div>
                           <span *ngIf="ubo.uboEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                       </div>
                    </div>
                   <div class="col-md-9 col-sm-12">
                      <ul>
                         <li>
                            <div class="seprator-section">
                               <div class="row">
                                  <div class="col-md-12">
                                     <h4>{{entityType}} Information</h4>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Screening ID:</label></li>
                                        <li class="col-md-6" ><span >{{screeningId}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Full Name:</label></li>
                                        <li class="col-md-6"><span>{{fname}}</span></li>
                                     </ul>
                                  </div>
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Father Name:</label></li>
                                        <li class="col-md-6"><span>N/A</span></li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Onboarded By:</label></li>
                                        <li class="col-md-6"><span> {{onboardedBy}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Gender:</label></li>
                                        <li class="col-md-6"><span>{{gender}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Date of Birth:</label></li>
                                        <li class="col-md-6"><span>{{dob}}</span>
                                        </li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Country of Residence:</label></li>
                                        <li class="col-md-6"><span class="">{{countryOfResidence}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Nationality:</label></li>
                                        <li class="col-md-6"><span class="">{{nationality}}</span></li>
                                     </ul>
                                  </div> -->
                                  <!---->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Is CRS:</label></li>
                                        <li class="col-md-6"><span>No</span></li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Resident Status:</label></li>
                                        <li class="col-md-6"><span>{{residenceStatus}}</span></li>
                                     </ul>
                                  </div> -->
                                  <!---->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>National ID Card Number</label></li>
                                        <li class="col-md-6"><span>{{eid}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>National ID Expiry</label></li>
                                        <li class="col-md-6"><span>{{emiratesExpiry}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Passport Number:</label></li>
                                        <li class="col-md-6"><span>{{passportNumber}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Passport Number Expiry:</label></li>
                                        <li class="col-md-6"><span>
                                          {{passportExpiry}}</span>
                                        </li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Record Last Updated:</label></li>
                                        <li class="col-md-6"><span>{{recordLastUpdated}}</span></li>
                                     </ul>
                                  </div> -->
                                  <!---->
                               </div>
                            </div>
                         </li>
                      </ul>
                      <ul>
                         <li>
                            <!-- <div class="seprator-section">
                               <div class="row">
                                  <div class="col-md-12">
                                     <h4>Contact Information</h4>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Address:</label></li>
                                        <li class="col-md-6"><span>{{areaDesc}}</span></li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>City:</label></li>
                                        <li class="col-md-6"><span>{{city}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>State:</label></li>
                                        <li class="col-md-6"><span>{{emirate}}</span></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Zip/Postal Code:</label></li>
                                        <li class="col-md-6"><span>{{poBox}}</span></li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Contact Number:</label></li>
                                        <li class="col-md-6"><span class="">
                                          {{edcMobile}} </span>
                                        </li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Email Address:</label></li>
                                        <li class="col-md-6"><span>{{emailId}}</span></li>
                                     </ul>
                                  </div>
                               </div>
                            </div> -->
                         </li>
                      </ul>
                      <ul>
                         <li>
                            <!-- <div class="seprator-section">
                               <div class="row">
                                  <div class="col-md-12">
                                     <h4>Profile Information</h4>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Work Type:</label></li>
                                        <li class="col-md-6"><span>{{occupation}}</span></li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Industry:</label></li>
                                        <li class="col-md-6"><span>N/A</span></li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Products:</label></li>
                                        <li class="col-md-6"><span>
                                           N/A
                                           </span>
                                        </li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Product Offered:</label></li>
                                        <li class="col-md-6"><span>
                                           N/A
                                           </span>
                                        </li>
                                     </ul>
                                  </div> -->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Delivery Channel:</label></li>
                                        <li class="col-md-6"><span>{{deliveryChannel}}</span></li>
                                     </ul>
                                  </div> -->
                                  <!----><!----><!----><!---->
                                  <!-- <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Company Name:</label></li>
                                        <li class="col-md-6"><span>N/A</span></li>
                                     </ul>
                                  </div> -->
                               <!-- </div>
                            </div> -->
                         </li>
                      </ul>
                      <!----><!---->
                      <ul>
                       <li>
                          <div class="seprator-section">
                             <div class="row">
                                <div class="col-md-12">
                                   <h4>Screening Configuration</h4>
                                </div>
                             </div>
                             <div class="row">
                                <div class="col-md-6">
                                   <ul class="row">
                                      <li class="col-md-6"><label>Match Score</label>
                                      </li>
                                      <li class="col-md-6"><span>{{screeningConfig?screeningConfig.matchScore:"0"}}%</span></li>
                                   </ul>
                                </div>
                             </div>
                             <div class="row">
                                <div class="col-md-6">
                                   <ul class="row">
                                      <li class="col-md-6"><label>Alias Enable</label>
                                      </li>
                                      <li class="col-md-6"><span>{{screeningConfig?screeningConfig.aliasSearch:"NA"}}</span></li>
                                   </ul>
                                </div>
                                <div class="col-md-6">
                                   <ul class="row">
                                      <li class="col-md-6"><label>RCA Enable</label>
                                      </li>
                                      <li class="col-md-6"><span>{{screeningConfig?screeningConfig.rcaSearch:"NA"}}</span></li>
                                   </ul>
                                </div>
                             </div>
                             <div class="row">
                                <div class="col-md-12">
                                   <ul class="row">
                                      <li class="col-md-2"><label>Search List </label>
                                      </li>
                                      <li class="col-md-10"><span>{{screeningConfig?screeningConfig.searchList:"NA"}}</span></li>
                                   </ul>
                                </div>
                             </div>
                          </div>
                       </li>
                    </ul>
                      <ul>
                         <li>
                            <!-- <div class="seprator-section">
                               <div class="row">
                                  <div class="col-md-12">
                                     <h4>Source Of Wealth</h4>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>SOURCE OF WEALTH</label></li>
                                        <li class="col-md-6"></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Other</label></li>
                                        <li class="col-md-6"><span>N/A</span></li>
                                     </ul>
                                  </div>
                               </div>
                            </div> -->
                         </li>
                      </ul>
                      <ul>
                         <li>
                            <!-- <div class="seprator-section">
                               <div class="row">
                                  <div class="col-md-12">
                                     <h4>Source Of Funds</h4>
                                  </div>
                               </div>
                               <div class="row">
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>SOURCE OF FUNDS</label></li>
                                        <li class="col-md-6"></li>
                                     </ul>
                                  </div>
                                  <div class="col-md-6">
                                     <ul class="row">
                                        <li class="col-md-6"><label>Other</label></li>
                                        <li class="col-md-6"><span>N/A</span></li>
                                     </ul>
                                  </div>
                               </div>
                            </div> -->
                         </li>
                      </ul>
                   </div>
                </div>
             </div>
          </div>
          <div id="nameScreening" class="tab-pane fade" [class.show]="activeTab === 'nameScreening'">
           <div class="container rounded bg-white mt-5 mb-5">
             <div class="row">
               <div class="col-md-3 border-right">
                  <!-- <div class="d-flex flex-column align-items-center text-center p-3 py-5"><img class="rounded-circle mt-5" width="150px" src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"><span class="font-weight-bold"></span><span> </span></div> -->
                 <div [class]="merchantEnableClass" (click)="merchantSelect()">
                    <div class="contact-info">
                        <h3>{{merchantFullName}}</h3>
                        <p>Merchant</p>
                    </div>
                    <span *ngIf="merchantEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                </div>
                    <div [class]="ubo.uboEnableClass" *ngFor="let ubo of UBOList;let i = index" (click)="selectUBOTab(ubo,i)">
                       <div class="contact-info">
                           <h3>{{ubo.shareHolderName}}</h3>
                           <p>Type of Shareholder : {{ubo?.typeOfShareHolder}}</p>
                       </div>
                       <span *ngIf="ubo.uboEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                   </div>
                </div>
                <div class="col-md-9 col-sm-12">
                   <ul>
                      <li>
                         <div class="seprator-sec">
                            <div class="row">
                               <div class="col-md-12">
                                  <h4>{{entityType}} Information</h4>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Screening ID:</label></li>
                                     <li class="col-md-6"><span>{{screeningId}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Full Name:</label></li>
                                     <li class="col-md-6"><span>{{fname}}</span></li>
                                  </ul>
                               </div>
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Father Name:</label></li>
                                     <li class="col-md-6"><span>N/A</span></li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Onboarded By:</label></li>
                                     <li class="col-md-6"><span>{{onboardedBy}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Gender:</label></li>
                                     <li class="col-md-6"><span>{{gender}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Date of Birth:</label></li>
                                     <li class="col-md-6"><span>
                                      {{dob}}</span>
                                     </li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Country of Residence:</label></li>
                                     <li class="col-md-6"><span class="">{{countryOfResidence}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Nationality:</label></li>
                                     <li class="col-md-6"><span class="">{{nationality}}</span></li>
                                  </ul>
                               </div> -->
                               <!---->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Is CRS:</label></li>
                                     <li class="col-md-6"><span>No</span></li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Resident Status:</label></li>
                                     <li class="col-md-6"><span>{{residenceStatus}}</span></li>
                                  </ul>
                               </div> -->
                               <!---->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>National ID Card Number</label></li>
                                     <li class="col-md-6"><span>{{eid}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>National ID Expiry</label></li>
                                     <li class="col-md-6"><span>{{emiratesExpiry}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Passport Number:</label></li>
                                     <li class="col-md-6"><span>{{passportNumber}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Passport Number Expiry:</label></li>
                                     <li class="col-md-6"><span>{{passportExpiry}}
                                        </span>
                                     </li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Record Last Updated:</label></li>
                                     <li class="col-md-6"><span>{{recordLastUpdated}}</span></li>
                                  </ul>
                               </div> -->
                            </div>
                         </div>
                         <div class="seprator-section">
                           <div class="row">
                              <div class="col-md-12">
                                 <h4>Screening Configuration</h4>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>Match Score</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.matchScore:"0"}}%</span></li>
                                 </ul>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>Alias Enable</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.aliasSearch:"NA"}}</span></li>
                                 </ul>
                              </div>
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>RCA Enable</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.rcaSearch:"NA"}}</span></li>
                                 </ul>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-12">
                                 <ul class="row">
                                    <li class="col-md-2"><label>Search List </label>
                                    </li>
                                    <li class="col-md-10"><span>{{screeningConfig?screeningConfig.searchList:"NA"}}</span></li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                      </li>
                   </ul>
                
                </div>
             </div>
          </div>
         </div>
          <div id="riskRating" class="tab-pane fade" [class.show]="activeTab === 'riskRating'">
           <div class="container rounded bg-white mt-5 mb-5">
             <div class="row">
               <div class="col-md-3 border-right">
                  <!-- <div class="d-flex flex-column align-items-center text-center p-3 py-5"><img class="rounded-circle mt-5" width="150px" src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"><span class="font-weight-bold"></span><span> </span></div> -->
                 <div [class]="merchantEnableClass" (click)="merchantSelect()">
                    <div class="contact-info">
                        <h3>{{merchantFullName}}</h3>
                        <p>Merchant</p>
                    </div>
                    <span *ngIf="merchantEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                </div>
                    <div [class]="ubo.uboEnableClass" *ngFor="let ubo of UBOList;let i = index" (click)="selectUBOTab(ubo,i)">
                       <div class="contact-info">
                           <h3>{{ubo.shareHolderName}}</h3>
                           <p>Type of Shareholder : {{ubo?.typeOfShareHolder}}</p>
                       </div>
                       <span *ngIf="ubo.uboEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                   </div>
                </div>
                <div class="col-md-9 col-sm-12">
                   <ul>
                      <li>
                         <div class="seprator-sec">
                            <div class="row">
                               <div class="col-md-12">
                                  <h4>{{entityType}} Information</h4>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Screening ID:</label></li>
                                     <li class="col-md-6"><span>{{screeningId}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Full Name:</label></li>
                                     <li class="col-md-6"><span>{{fname}}</span></li>
                                  </ul>
                               </div>
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Father Name:</label></li>
                                     <li class="col-md-6"><span>N/A</span></li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Onboarded By:</label></li>
                                     <li class="col-md-6"><span>{{onboardedBy}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Gender:</label></li>
                                     <li class="col-md-6"><span>{{gender}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Date of Birth:</label></li>
                                     <li class="col-md-6"><span>
                                        {{dob}}</span>
                                     </li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Country of Residence:</label></li>
                                     <li class="col-md-6"><span class="">{{countryOfResidence}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Nationality:</label></li>
                                     <li class="col-md-6"><span>{{nationality}}</span></li>
                                  </ul>
                               </div> -->
                               <!---->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Is CRS:</label></li>
                                     <li class="col-md-6"><span>No</span></li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Resident Status:</label></li>
                                     <li class="col-md-6"><span>{{residenceStatus}}</span></li>
                                  </ul>
                               </div> -->
                               <!---->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>National ID Card Number</label></li>
                                     <li class="col-md-6"><span>{{eid}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>National ID Expiry</label></li>
                                     <li class="col-md-6"><span>{{emiratesExpiry}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Passport Number:</label></li>
                                     <li class="col-md-6"><span>{{passportNumber}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Passport Number Expiry:</label></li>
                                     <li class="col-md-6"><span>
                                        {{passportExpiry}}</span>
                                     </li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Record Last Updated:</label></li>
                                     <li class="col-md-6"><span>{{recordLastUpdated}}</span></li>
                                  </ul>
                               </div> -->
                            </div>
                         </div>
                         <div class="seprator-section">
                           <div class="row">
                              <div class="col-md-12">
                                 <h4>Screening Configuration</h4>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>Match Score</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.matchScore:"0"}}%</span></li>
                                 </ul>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>Alias Enable</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.aliasSearch:"NA"}}</span></li>
                                 </ul>
                              </div>
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>RCA Enable</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.rcaSearch:"NA"}}</span></li>
                                 </ul>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-12">
                                 <ul class="row">
                                    <li class="col-md-2"><label>Search List </label>
                                    </li>
                                    <li class="col-md-10"><span>{{screeningConfig?screeningConfig.searchList:"NA"}}</span></li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                      </li>
                   </ul>
                
                </div>
             </div>
          </div>
          </div>
          <div id="activityTimeline" class="tab-pane fade" [class.show]="activeTab === 'activityTimeline'">
           <div class="container rounded bg-white mt-5 mb-5">
             <div class="row">
               <div class="col-md-3 border-right">
                  <!-- <div class="d-flex flex-column align-items-center text-center p-3 py-5"><img class="rounded-circle mt-5" width="150px" src="https://st3.depositphotos.com/15648834/17930/v/600/depositphotos_179308454-stock-illustration-unknown-person-silhouette-glasses-profile.jpg"><span class="font-weight-bold"></span><span> </span></div> -->
                 <div [class]="merchantEnableClass" (click)="merchantSelect()">
                    <div class="contact-info">
                        <h3>{{merchantFullName}}</h3>
                        <p>Merchant</p>
                    </div>
                    <span *ngIf="merchantEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                </div>
                    <div [class]="ubo.uboEnableClass" *ngFor="let ubo of UBOList;let i = index" (click)="selectUBOTab(ubo,i)">
                       <div class="contact-info">
                           <h3>{{ubo.shareHolderName}}</h3>
                           <p>Type of Shareholder : {{ubo?.typeOfShareHolder}}</p>
                       </div>
                       <span *ngIf="ubo.uboEnableClass==='contact selected'" class="feather icon-chevron-right"></span>
                   </div>
                </div>
                <div class="col-md-9 col-sm-12">
                   <ul>
                      <li>
                         <div class="seprator-sec">
                            <div class="row">
                               <div class="col-md-12">
                                  <h4>{{entityType}} Information</h4>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Screening ID:</label></li>
                                     <li class="col-md-6"><span>{{screeningId}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Full Name:</label></li>
                                     <li class="col-md-6"><span>{{fname}}</span></li>
                                  </ul>
                               </div>
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Father Name:</label></li>
                                     <li class="col-md-6"><span>N/A</span></li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Onboarded By:</label></li>
                                     <li class="col-md-6"><span>{{onboardedBy}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Gender:</label></li>
                                     <li class="col-md-6"><span>{{gender}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Date of Birth:</label></li>
                                     <li class="col-md-6"><span>
                                        {{dob}}</span>
                                     </li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Country of Residence:</label></li>
                                     <li class="col-md-6"><span class="">{{countryOfResidence}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Nationality:</label></li>
                                     <li class="col-md-6"><span class="">{{nationality}}</span></li>
                                  </ul>
                               </div> -->
                               <!---->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Is CRS:</label></li>
                                     <li class="col-md-6"><span>No</span></li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Resident Status:</label></li>
                                     <li class="col-md-6"><span>{{residenceStatus}}</span></li>
                                  </ul>
                               </div> -->
                               <!---->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>National ID Card Number</label></li>
                                     <li class="col-md-6"><span>{{eid}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>National ID Expiry</label></li>
                                     <li class="col-md-6"><span>{{emiratesExpiry}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Passport Number:</label></li>
                                     <li class="col-md-6"><span>{{passportNumber}}</span></li>
                                  </ul>
                               </div>
                               <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Passport Number Expiry:</label></li>
                                     <li class="col-md-6"><span>
                                        {{passportExpiry}}</span>
                                     </li>
                                  </ul>
                               </div> -->
                               <!-- <div class="col-md-6">
                                  <ul class="row">
                                     <li class="col-md-6"><label>Record Last Updated:</label></li>
                                     <li class="col-md-6"><span>{{recordLastUpdated}}</span></li>
                                  </ul>
                               </div> -->
                            </div>
                         </div>
                         <div class="seprator-section">
                           <div class="row">
                              <div class="col-md-12">
                                 <h4>Screening Configuration</h4>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>Match Score</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.matchScore:"0"}}%</span></li>
                                 </ul>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>Alias Enable</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.aliasSearch:"NA"}}</span></li>
                                 </ul>
                              </div>
                              <div class="col-md-6">
                                 <ul class="row">
                                    <li class="col-md-6"><label>RCA Enable</label>
                                    </li>
                                    <li class="col-md-6"><span>{{screeningConfig?screeningConfig.rcaSearch:"NA"}}</span></li>
                                 </ul>
                              </div>
                           </div>
                           <div class="row">
                              <div class="col-md-12">
                                 <ul class="row">
                                    <li class="col-md-2"><label>Search List </label>
                                    </li>
                                    <li class="col-md-10"><span>{{screeningConfig?screeningConfig.searchList:"NA"}}</span></li>
                                 </ul>
                              </div>
                           </div>
                        </div>
                      </li>
                   </ul>
                
                </div>
             </div>

             <div class="row">

              <div class="col-12">

                <div class="card">

                  <div class="card-body">

                    <h4 class="card-title">Timeline</h4>



                    <div class="mt-5">

                      <div class="timeline"> 

                        <div class="timeline-wrapper timeline-wrapper-warning" *ngFor="let content of reversedList;let activityIndex = index" [ngClass]="{'timeline-inverted timeline-wrapper-danger': 0 === activityIndex % 2}">

                          <div class="timeline-badge"></div>

                          <div class="timeline-panel">

                            <div class="timeline-heading">

                              <h6 class="timeline-title">{{reversedList[activityIndex].addedBy}}</h6>

                            </div>

                            <div class="timeline-body">

                              <p>{{reversedList[activityIndex].narration}}</p>

                            </div>

                            <div class="timeline-footer d-flex align-items-center flex-wrap">

                               

                                <span></span>

                                <span class="ml-md-auto font-weight-bold">{{reversedList[activityIndex].addedOn}}</span>

                            </div>

                          </div>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>

              </div>

            </div>
          </div>
          </div>
       </div>
    </div>
    <div>
     <h3 class="p-2" *ngIf="activeTab === 'customerProfile'">Alert Summary</h3>
    </div>
    <div class="card mt-2 p-4" *ngIf="activeTab === 'customerProfile'">
     <h5 class="mb-2">Name Screening Result</h5>

     <div class="row pb-4 border-bottom">
       <div class="col-md-3">
         <div class="input-group">
           <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
           <input type="text" class="form-control" value="Sanction" disabled>
           <span class="input-group-text" id="check-addon"><i [attr.class]="sanctionHitClass" [attr.style]="sanctionHitColor"></i></span>
         </div>
     </div>
     <div class="col-md-3">
       <div class="input-group">
         <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
         <input type="text" class="form-control" value="PEP" disabled>
         <span class="input-group-text" id="check-addon"><i [attr.class]="pepHitClass" [attr.style]="pepHitColor"></i></span>
       </div>
   </div>
   <div class="col-md-3">
     <div class="input-group">
       <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
       <input type="text" class="form-control" value="Enforcement" disabled>
       <span class="input-group-text" id="check-addon"><i [attr.class]="enforcementHitClass" [attr.style]="enforcementHitColor"></i></span>
     </div>
 </div>
 <div class="col-md-3">
   <div class="input-group">
     <span class="input-group-text" id="minus-addon"><i data-feather="globe" class="feather icon-minus"></i></span>
     <input type="text" class="form-control" value="Adverse Media" disabled>
     <span class="input-group-text" id="check-addon"><i [attr.class]="adverseMediaHitClass" [attr.style]="adverseMediaHitColor"></i></span>
   </div>
</div>
 </div>
 <div class="row mt-2">
   <!-- <div class="col-md-3">
     <h5  class="mb-2">Politically Exposed Person (PEP)</h5>
     <div class="input-group">
       <span class="input-group-text" id="minus-addon"><i data-feather="file"class="feather icon-minus"></i></span>
       <input type="text" class="form-control" value="Self Declared PEP" disabled>
       <span class="input-group-text" id="check-addon"><i [attr.class]="isSelfPepHitClass" [attr.style]="isSelfPepHitColor"></i></span>
     </div>
 </div> -->
 
 <div class="col-md-3">
   <h5 class="mb-2">Risk Rating Result</h5>
   <div class="input-group">
     <span class="input-group-text" id="minus-addon"><i data-feather="bar-chart-2" class="feather icon-minus"></i></span>
     <input type="text" class="form-control" [attr.value]="riskRatingHit" disabled>
     <span class="input-group-text" id="check-addon"><i [attr.class]="riskRatingHitClass" [attr.style]="riskRatingHitColor"></i></span>
   </div>
</div>
</div>
    </div>
    <div class="row">
     <div class="col-9">
     <!-- <h3 class="p-2" *ngIf="activeTab === 'customerProfile'">Last Review</h3> -->
     <h3 class="p-2" *ngIf="activeTab === 'nameScreening' && tableVisible" >Name Screening Hit Details</h3>
     <h3 class="p-2" *ngIf="activeTab === 'nameScreening' && !tableVisible">Screening Hit Detail</h3>

     <h3 class="p-2" *ngIf="activeTab === 'riskRating'">Risk Factor Matrix</h3>
     </div>
     

    </div>
    <!-- <div class="card mt-2 p-4"  *ngIf="activeTab === 'customerProfile'">
     <div class="details-section">
       <h5>  <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil" style="width: 3%; "> <span class="float-end"></span></h5>
      <p> <span class="status-types ml-2"> Admin</span> . <span class="status-types ml-2"> May 23, 2024 10:11 am </span></p>
   <p class="date-content">Submitted KYC Review Status and changed KYC Status to <b></b> with the following comment,</p>
   <strong></strong>
 </div>
    </div> -->
    <div *ngIf="activeTab === 'nameScreening'">
       <div class="card table-responsive"  *ngIf="tableVisible">
        <div class="toggle-container m-3" *ngIf="isShowInitiate">
           <!-- <label class="toggle"> -->
               <!-- <input type="checkbox" (click)="toggleGenuine()"> -->
               <!-- <span class="slider"></span> -->
           <!-- </label> -->
           <!-- <span>MARK ALL AS NOT RELEVANT</span> -->
       </div>
        <table class="table table-bordered">
               <thead class="thead-light">
                   <tr role="row">
                       <th id="sortable" scope="col">FULL NAME</th>
                       <th id="sortable" scope="col">DOB</th>
                       <!-- <th id="sortable" scope="col">ID Number</th> -->
                       <th id="sortable" scope="col">COUNTRY</th>
                       <th id="sortable" scope="col">Source List</th>
                       <th id="sortable" scope="col">Score</th>
                       <th id="sortable" scope="col" class="text-center">SANCTION</th>
                       <th id="sortable" scope="col" class="text-center">PEP</th>
                       <th id="sortable" scope="col" class="text-center">Enforcement</th>
                       <th id="sortable" scope="col" class="text-center">Adverse Media</th>
                       <th id="sortable" scope="col">HIT Determination</th>
                       <th id="sortable" scope="col" class="text-center">RELEVANT</th>
                       <th id="sortable" scope="col" class="text-center">NOT RELEVANT</th>
                       <th id="sortable" scope="col">Comments</th>
                       <th id="sortable" scope="col">Action</th>
                   </tr>
               </thead>
               <tbody>

                 <tr role="row" *ngFor="let item of nameScreeningHitsData; let nameScreeningHitsLength = index" >
                    <td><a class="cursor-pointer" (click)="toggleTableVisibility(item,nameScreeningHitsLength)">{{nameScreeningHitsData[nameScreeningHitsLength].screeningData.name? nameScreeningHitsData[nameScreeningHitsLength]?.screeningData.name:'NA'}}</a></td>
                    <td >{{nameScreeningHitsData[nameScreeningHitsLength].screeningData.dob && nameScreeningHitsData[nameScreeningHitsLength].screeningData.dob.length!=0 && nameScreeningHitsData[nameScreeningHitsLength].screeningData.dob[0].dob? nameScreeningHitsData[nameScreeningHitsLength].screeningData.dob[0].dob: 'NA'}}</td>
                    <!-- <td >NA</td> -->
                    <!-- <td >{{nameScreeningHitsData[nameScreeningHitsLength].screeningData.nationality && nameScreeningHitsData[nameScreeningHitsLength].screeningData.nationality.length>0 && nameScreeningHitsData[nameScreeningHitsLength].screeningData.nationality[0].nationality? nameScreeningHitsData[nameScreeningHitsLength].screeningData.nationality[0].nationality:'NA'}}</td> -->
                    <td>{{ getCountryNames(nameScreeningHitsData[nameScreeningHitsLength]) }}</td>
                    <td >{{nameScreeningHitsData[nameScreeningHitsLength].screeningData.sourceList ?nameScreeningHitsData[nameScreeningHitsLength].screeningData.sourceList:'NA'}}</td>
                    <td><span class="text-decoration-underline" style="color: orange;" (click)="openScoreBreakdown(content,nameScreeningHitsLength,nameScreeningHitsData[nameScreeningHitsLength].scoreObject)">{{nameScreeningHitsData[nameScreeningHitsLength].score ?nameScreeningHitsData[nameScreeningHitsLength].score:'NA'}}</span></td>
                    <td  class="text-center"><div class="status-type-icon cursor-pointer"><i [attr.class]="getIconFromStringCondition(nameScreeningHitsData[nameScreeningHitsLength].sanction)"></i></div></td>
                    <td  class="text-center"><div class="status-type-icon"><i [attr.class]="getIconFromStringCondition(nameScreeningHitsData[nameScreeningHitsLength].pep)" ></i></div></td>
                    <td  class="text-center"><div class="status-type-icon"><i [attr.class]="getIconFromStringCondition(nameScreeningHitsData[nameScreeningHitsLength].enforcement)"></i></div></td>
                    <td class="text-center"><div class="status-type-icon"><i [attr.class]="getIconFromStringCondition(nameScreeningHitsData[nameScreeningHitsLength].adverseMedia)" ></i></div></td>
                    <td class="mobile-text-center"><div><span class="status-view high-risk"><i  class="feather icon-wrong"></i><button class="btn btn-warning" disabled [ngClass]="{'btn-success': isGenuine, 'btn-warning': !isGenuine}" >{{isGenuine?'Not Relevant':'Potential'}}</button></span></div></td> 
                    
                    <td  class="text-center mobile-text-center"><div class="custom-control custom-radio"><input type="radio" [checked]="map.get(nameScreeningHitsData[nameScreeningHitsLength]?._id)?.relevancy==='relavent'" name="nshRadio{{nameScreeningHitsLength}}" value="relavent" [disabled]="!isShowInitiate" autocomplete="off"></div></td> 
                    <td class="text-center mobile-text-center"><div class="custom-control custom-radio"><input type="radio" [checked]="map.get(nameScreeningHitsData[nameScreeningHitsLength]?._id)?.relevancy=== 'nonRelavent' || (isGenuine && !isShowInitiate)" name="nshRadio{{nameScreeningHitsLength}}" value="nonRelavent" [disabled]="!isShowInitiate" autocomplete="off"></div></td>
                   
                    <td><input style="width: 225px;" name="remark{{nameScreeningHitsLength}}"[disabled]="!isShowInitiate" placeholder="Enter your comments..." value="{{map.get(nameScreeningHitsData[nameScreeningHitsLength]?._id)?.remark}}" class="form-control"/><input  [value]="nameScreeningHitsData[nameScreeningHitsLength]._id" type="hidden"></td>
                    <td><i style="width: 150px;" id="saveRemarkIcon{{nameScreeningHitsLength}}" (click)="saveRemarks(item,nameScreeningHitsLength)" class="feather icon-save" data-disabled="false"></i></td>
                </tr>
                   <!-- Add more rows as needed -->
               </tbody>
           </table>
           <br>
           <h5 class="text-center" *ngIf="nameScreeningHitsData.length == 0">NO DATA FOUND</h5>
           <br>
       </div>

       <div class="card"  *ngIf="!tableVisible">
        <div class="row">
           <div class="col-12 d-flex justify-content-end">
             <button class="btn btn-sm btn-danger col-sm-2 m-3" (click)="toggleTableVisibility1()">Back</button>
           </div>
         </div>
         <ul id="tabMenu" class="nav nav-tabs">
           <li class="nav-item">
              <a class="nav-link" [class.active]="activeTabSub === 'profile'" (click)="switchTabSub('profile')">Profile Data</a>
           </li>
           <li class="nav-item">
              <a class="nav-link" [class.active]="activeTabSub === 'more'" (click)="switchTabSub('more')">More Details</a>
           </li>
           <li class="nav-item">
              <a class="nav-link" [class.active]="activeTabSub === 'relative'" (click)="switchTabSub('relative')">Relative Close Associates</a>
           </li>
           <li class="nav-item">
              <a class="nav-link" [class.active]="activeTabSub === 'media'" (click)="switchTabSub('media')">Media</a>
           </li>
           <li class="nav-item">
              <a class="nav-link" [class.active]="activeTabSub === 'fields'" (click)="switchTabSub('fields')">Fields</a>
           </li>

        </ul>
        <div class="tab-content" >
             <div id="profile" class="tab-pane fade p-4" [class.show]="activeTabSub === 'profile'">
               <div class="pt-2 form-details">
                 <div class="row">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">Father Name</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.fathersName?nameScreeningHitsData[selectedRow].screeningData.fathersName:'NA'}}</span>
                     </div>
                 </div>

                 <!-- <div class="row">
                     <div class="col-md-12">
                         <div class="d-flex">
                             <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                                 <span class="text-muted d-block label">ID Type </span>
                                 <span class="pl-2 value">Passport</span>
                             </div>
                             <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                                 <span class="text-muted d-block label">ID Number </span>
                                 <span class="pl-2 value">D00000897</span>
                             </div>
                         </div>
                     </div>
                 </div> -->
             
                
                 <div class="row">
                    <div *ngFor="let content of nameScreeningHitsData[selectedRow].screeningData.dob ; let dobIndex = index">
                        <div class="d-flex">
                            <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                                <span class="text-muted d-block label">Date of Birth {{dobIndex+1}}</span>
                                <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.dob[dobIndex].dob}}</span>
                            </div>
                        </div>
                    </div>

                </div>
             
                <div class="row">
                 <div *ngFor="let content of nameScreeningHitsData[selectedRow].screeningData.nationality ; let myIndex1 = index">
                     <div class="d-flex">
                         <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                             <span class="text-muted d-block label">Nationality {{myIndex1+1}}</span>
                             <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.nationality[myIndex1].nationality}}</span>
                         </div>
                     </div>
                 </div>

             </div>
             
                 <div class="row">
                     <div *ngFor="let content of nameScreeningHitsData[selectedRow].screeningData.alias ; let myIndex1 = index">
                         <div class="d-flex">
                             <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                                 <span class="text-muted d-block label">Alias Type {{myIndex1+1}}</span>
                                 <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.alias[myIndex1].alias_type}}</span>
                             </div>
                             <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                                 <span class="text-muted d-block label">Alias {{myIndex1+1}}</span>
                                 <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.alias[myIndex1].alias}}</span>
                             </div>
                         </div>
                     </div>

                 </div>

                 <div class="row">
                    <div *ngFor="let content of nameScreeningHitsData[selectedRow].screeningData.identificationType ; let myIndex1 = index">
                        <div class="d-flex">
                            <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                                <span class="text-muted d-block label">ID Type {{myIndex1+1}}</span>
                                <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.identificationType[myIndex1].id_type}}</span>
                            </div>
                            <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                                <span class="text-muted d-block label">ID Type {{myIndex1+1}}</span>
                                <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.identificationType[myIndex1].id_number}}</span>
                            </div>
                        </div>
                    </div>

                </div>
             
                 <div class="row">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">Gender</span>
                         <span class="pl-2 value">
                             <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACCSURBVHgB7ZRBDkAwEEV/sOcGeiw7buIojoCTOIIrcAKmaZuw65ARYl7ykm7av/g/BZS3kYJHQVbk4hWhJzdy9oFRJOARHjYQxJAd2eDL1HBdBFsIMMGVfrSMucgpPnpNd0Iu88+QEeevZCBXCGCny1qWRYtnkYGHLT/3Z5HSlWfYAd1fFrIoTPOsAAAAAElFTkSuQmCC" class="mr-1 d-inline"> {{nameScreeningHitsData[selectedRow].screeningData.gender?nameScreeningHitsData[selectedRow].screeningData.gender:'NA'}}
                         </span>
                     </div>
                 </div>
             
                 <div class="row">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">Category</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.category}}</span>
                     </div>
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">Source List</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.sourceList}}</span>
                     </div>
                 </div>
             
                 <div class="row">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">List Type</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.listType}}</span>
                     </div>
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">List Category</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.listCategory}}</span>
                     </div>
                 </div>
             </div>
             
             </div>
             <div id="more" class="tab-pane fade  p-4" [class.show]="activeTabSub === 'more'">
               <div class="pt-2 form-details">
                 <div class="row">
                     <div class="col-md-4 m-2 field">
                         <span class="text-muted d-block label">Place Of Birth</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.pob ? nameScreeningHitsData[selectedRow].screeningData.pob:'NA'}}</span>
                     </div>
                 </div>

                 <div class="row"  *ngIf="nameScreeningHitsData[selectedRow].screeningData.keyword">
                    <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                        <span class="text-muted d-block label">Keyword</span>
                        <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.keyword[0] ? keyword(nameScreeningHitsData[selectedRow].screeningData.keyword[0]):'NA' }}</span>
                    </div>
                 </div>
                 

                   <div class="row"  *ngIf="nameScreeningHitsData[selectedRow].screeningData.description1 && nameScreeningHitsData[selectedRow].screeningData.description1[0]">
                    <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                        <span class="text-muted d-block label">Description</span>
                        <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.description1[0].value ? nameScreeningHitsData[selectedRow].screeningData.description1[0].value:'NA'}}</span>
                    </div>
                 </div>

                 <div class="row"  *ngIf="nameScreeningHitsData[selectedRow].screeningData.description1 && nameScreeningHitsData[selectedRow].screeningData.description1[1]">
                    <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                        <a class="pl-2 value" href="{{nameScreeningHitsData[selectedRow].screeningData.description1[1].value}}" target="_blank">Reference</a>
                    </div>
                 </div>
       
                 <div class="row"  *ngFor="let key of keys()">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">{{key}}</span>
                         <span class="pl-2 value">{{extraInfoObject[key]}}</span>
                     </div>
                 </div>


                <div class="row"  *ngFor="let content of nameScreeningHitsData[selectedRow].screeningData.head_bounty; let headBountyIndex = index ">
                 <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                     <span class="text-muted d-block label">Head Bounty</span>
                     <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.head_bounty[headBountyIndex]}}</span>
                 </div>
             </div>

             <div class="row"  *ngFor="let content of nameScreeningHitsData[selectedRow].screeningData.role_type; let roleTypeIndex = index ">
              <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                  <span class="text-muted d-block label">Designation {{[roleTypeIndex]}}</span>
                  <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.role_type[roleTypeIndex].designation}}</span>
              </div>
           </div>
           <div class="row"  *ngFor="let content of nameScreeningHitsData[selectedRow].screeningData.role_type; let roleTypeIndex1 = index ">
              <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                 <span class="text-muted d-block label">Start Date {{[roleTypeIndex1+1]}}</span>
                 <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.role_type[roleTypeIndex1].start_date ? nameScreeningHitsData[selectedRow].screeningData.role_type[roleTypeIndex1].start_date:'NA'}}</span>
             </div>
             <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
              <span class="text-muted d-block label">End Date {{[roleTypeIndex1+1]}}</span>
              <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.role_type[roleTypeIndex1].end_date ? nameScreeningHitsData[selectedRow].screeningData.role_type[roleTypeIndex1].end_date:'NA'}}</span>
          </div>
        </div>
          

          <div class="row" >
           <div class="col-md-5 m-2 border-bottom border-bottom-2 field" *ngIf="nameScreeningHitsData[selectedRow].screeningData.date_exclusion">
               <span class="text-muted d-block label">Date Exclusion</span>
               <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.date_exclusion? nameScreeningHitsData[selectedRow].screeningData.date_exclusion:"NA"}}</span>
           </div>
           <div class="col-md-5 m-2 border-bottom border-bottom-2 field" *ngIf="nameScreeningHitsData[selectedRow].screeningData.date_inclusion">
              <span class="text-muted d-block label">Date Inclusion</span>
              <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.date_inclusion? getFormattedDate(nameScreeningHitsData[selectedRow].screeningData.date_inclusion) :"NA"}}</span>
          </div>
       </div>
                 <div class="row">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field" *ngIf="nameScreeningHitsData[selectedRow].screeningData.deceased_dissolved_date">
                         <span class="text-muted d-block label">Deceased Dissolved Status</span>
                         <span class="pl-2 value">
                             <span class="d-flex">
                                 <span class="icon-status danger mr-2"><i class="icon-wrong"></i></span>
                                 {{nameScreeningHitsData[selectedRow].screeningData.deceased_dissolved_date?nameScreeningHitsData[selectedRow].screeningData.deceased_dissolved_date:"NA"}}
                             </span>
                         </span>
                     </div>
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field" *ngIf="nameScreeningHitsData[selectedRow].screeningData.deceased_dissolved_status">
                         <span class="text-muted d-block label">Deceased Dissolved Date</span>
                         <span class="pl-2 value"> {{nameScreeningHitsData[selectedRow].screeningData.deceased_dissolved_status?nameScreeningHitsData[selectedRow].screeningData.deceased_dissolved_status:"NA"}}</span>
                     </div>
                 </div>
                 <div class="row">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field" *ngIf="nameScreeningHitsData[selectedRow].screeningData.addedOn">
                         <span class="text-muted d-block label">Added On</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.addedOn?nameScreeningHitsData[selectedRow].screeningData.addedOn.slice(0,10):"NA"}}</span>
                     </div>
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field" *ngIf="nameScreeningHitsData[selectedRow].screeningData.updatedOn">
                         <span class="text-muted d-block label">Updated On</span>
                         <span class="pl-2 value">{{nameScreeningHitsData[selectedRow].screeningData.updatedOn?nameScreeningHitsData[selectedRow].screeningData.updatedOn.slice(0,10):"NA"}}</span>
                     </div>
                 </div>
                 <div class="row">
                     <div class="col-md-5 m-2 border-bottom border-bottom-2 field">
                         <span class="text-muted d-block label">Status</span>
                         <span class="pl-2 value">
                             <span class="d-flex">
                                 <!-- <span class="icon-status success mr-2"><i class="icon-check"></i></span> -->
                                 Active
                             </span>
                         </span>
                     </div>
                 </div>
             </div>
             
             </div>
             <div id="relative" class="tab-pane fade  p-4" [class.show]="activeTabSub === 'relative'">
              <div class="card table-responsive">
              <table class="table table-bordered">
                 <thead class="thead-light">
                     <tr role="row">
                         <th id="sortable" scope="col">NAME</th>
                         <th id="sortable" scope="col">ASSOCIATION</th>
                         <th id="sortable" scope="col">DETAILS</th>
                     </tr>
                 </thead>
                 <tbody>
                   <tr role="row" *ngFor="let data of associations">
                      <td>{{data.name}}</td>
                      <td>{{data.association}}</td>
                      <td>{{data.details}}</td>
                  </tr>
                 </tbody>
             </table>
             <br>
                <h5 class="text-center" *ngIf="associations == null || associations.length == 0">NO DATA FOUND</h5>
                <br>
           </div>
           </div>

           <div id="relative" class="tab-pane fade  p-4" [class.show]="activeTabSub === 'media'">
              <div class="row d-flex">
                 <div class="form-group col-md-3" *ngFor="let media of mediaData">
                    <div class="card border-secondary cards" style="width: 18rem;">
                       <img class="card-img-top" src="{{media.imageUrl}}" onerror="this.src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRD4FE0yuWmNBJVLqgk1zdrR8yqqGaD-ixsbDcAfreV44qN5dKgBU3F6OgpIwEYBVs2RWI&usqp=CAU'" alt="Card image cap" style="height:12rem;">
                       <div class="card-body">
                          <a class="card-title" target="_blank" href="{{media.url}}" id="truncateLongTexts" data-toggle="tooltip" data-placement="top" title="{{media.title}}">{{media.title}}</a>
                          <hr>
                          <p class="card-text" id="truncateLongParam" data-toggle="tooltip" data-placement="top" title="{{media.snippet}}">{{media.snippet}} </p>
                          <hr>
                          <button type="button" class="btn btn-lg btn-primary" (click)="showKeywordModal(keywordShow,media.keywords)" >Keywords</button>
                          <hr>
                          <button type="button" class="btn btn-lg" id="tags" disabled>Sentiment Score: {{media.finalScore}}</button>
                       </div>
                    </div>
                 </div>
                 <br>
                 <h5 class="text-center" *ngIf="mediaData == null || mediaData.length == 0">NO DATA FOUND</h5>
                 <br>
              </div>
           </div>

           <div id="relative" class="tab-pane fade  p-4" [class.show]="activeTabSub === 'fields'">
              <div class="row" *ngFor="let fields of fieldsData">  <!-- Loop -->
                 <div class="col-md-12" *ngFor="let data of fields | keyvalue">
                    <div *ngIf="data.value && $any(data).value.length!=0">
                       <hr>
                       <label class="col-form-label">{{data.key}}</label>
                          <div class="col-md-12 m-2 border-bottom border-bottom-2 field" *ngFor="let dataList of $any(data).value;let i=index">
                             <span class="text-muted d-block label">{{i+1}}. {{dataList.source}}</span>
                             <span class="pl-2 value">{{dataList.value}}</span>
                          </div>
                    </div>
                 </div>
              </div>
              <br>
                <h5 class="text-center" *ngIf="fieldsData == null || fieldsData.length == 0">NO DATA FOUND</h5>
                <br>
           </div>


         </div>
       </div>
     </div>
    <!-- <div class="card mt-2 p-4"  *ngIf="activeTab === 'customerProfile'">
     <div class="details-section">
       <h5>  <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil" style="width: 3%; "><span class="float-end"><button class=" btn btn-danger btn-sm">Rejected</button></span></h5>
      <p> <span class="status-types ml-2"> Admin</span> . <span class="status-types ml-2"> May 23, 2024 10:11 am </span></p>
   <p class="date-content">Submitted KYC Review Status and changed KYC Status to <b>Rejected</b> with the following comment,</p>
   <strong>Rejected</strong>
 </div>
    </div> -->
    <div class="table-section risk-factor-table card mt-2" *ngIf="activeTab === 'riskRating'">
     <table class="table b-table">
         <thead>
             <tr>
                 <th id="sortable" scope="col" class="risk-factor">RISK FACTOR</th>
                 <th id="sortable" scope="col" class="text-center risk-score">SCORE</th>
                 <th id="sortable" scope="col" class="text-center risk-level">Risk Level</th>
             </tr>
         </thead>
         <tbody>
             <tr>
                 <td class="risk-factor">Country of Residence</td>
                 <td class="text-center risk-score">{{countryOfResidenceScore!=undefined?countryOfResidenceScore:"NA"}}</td>
                 <td class="text-center risk-level">
                     <div><span class="status-view low-risk"><span> {{countryOfResidenceLevel?countryOfResidenceLevel:"NA" | titlecase}}</span></span></div>
                 </td>
             </tr>
             <tr>
                 <td class="risk-factor">Delivery Channel</td>
                 <td class="text-center risk-score">{{deliveryChannelScore!=undefined?deliveryChannelScore:"NA"}}</td>
                 <td class="text-center risk-level">
                     <div><span class="status-view low-risk"><span> {{deliveryChannelLevel?deliveryChannelLevel:"NA" | titlecase}}</span></span></div>
                 </td>
             </tr>
             <tr>
                 <td class="risk-factor">Industry</td>
                 <td class="text-center risk-score">{{industryScore!=undefined?industryScore:"NA"}}</td>
                 <td class="text-center risk-level">
                     <div><span class="status-view low-risk"><span> {{industryLevel?industryLevel:"NA" | titlecase}}</span></span></div>
                 </td>
             </tr>
             <tr>
                 <td class="risk-factor">Nationality</td>
                 <td class="text-center risk-score">{{nationalityScore!=undefined?nationalityScore:"NA"}}</td>
                 <td class="text-center risk-level">
                     <div><span class="status-view low-risk"><span> {{nationalityLevel?nationalityLevel:"NA" | titlecase}}</span></span></div>
                 </td>
             </tr>
             <tr>
                 <td class="risk-factor">Product</td>
                 <td class="text-center risk-score">{{productScore!=undefined?productScore:"NA"}}</td>
                 <td class="text-center risk-level">
                     <div><span class="status-view low-risk"><span> {{productLevel?productLevel:"NA" | titlecase}}</span></span></div>
                 </td>
             </tr>
             <tr>
                 <td class="risk-factor">State</td>
                 <td class="text-center risk-score">{{stateScore!=undefined?stateScore:"NA"}}</td>
                 <td class="text-center risk-level">
                     <div><span class="status-view low-risk"><span> {{stateLevel?stateLevel:"NA" | titlecase}}</span></span></div>
                 </td>
             </tr>
             <!-- Add more rows as needed -->
             <tr class="b-table-bottom-row">
                 <td class="risk-factor">Base Rating</td>
                 <td class="text-center risk-score">{{baseRatingLevel!=undefined?baseRatingLevel:"NA" | titlecase}}</td>
                 <td class="text-center risk-level">
                     <div><span class="status-view low-risk"><span> {{baseRatingLevel?baseRatingLevel:"NA" | titlecase}}</span></span></div>
                 </td>
             </tr>
         </tbody>
     </table>
</div>
<div class="card table-section risk-factor-table mt-2" *ngIf="activeTab === 'riskRating'">
  <table class="table b-table">
      <thead>
          <tr>
              <th id="sortable" scope="col" class="risk-factor">RISK FACTOR OVERRIDE</th>
              <th id="sortable" scope="col" class="risk-score">Override To</th>
              <th id="sortable" scope="col" class="text-center risk-level">Risk Level</th>
          </tr>
      </thead>
      <tbody>
          <tr>
              <td class="risk-factor">Suspicious Transaction Report filed</td>
              <td class="risk-score">{{suspiciousActivityReportsScore?suspiciousActivityReportsScore:"NA"}}</td>
              <td class="text-center risk-level">
                  <div><span class="status-view low-risk"><span> {{suspiciousActivityReportsLevel?suspiciousActivityReportsLevel:"NA" | titlecase}} </span></span></div>
              </td>
          </tr>
          <tr>
           <td class="risk-factor">Sanction</td>
           <td class="risk-score">{{sanctionScore?sanctionScore:"NA"}}</td>
           <td class="text-center risk-level">
               <div><span class="status-view low-risk"><span> {{sanctionLevel?sanctionLevel:"NA" | titlecase}}</span></span></div>
           </td>
       </tr>
          <tr>
              <td class="risk-factor">Non Resident</td>
              <td class="risk-score">{{nonResidentScore?nonResidentScore:"NA"}}</td>
              <td class="text-center risk-level">
                  <div><span class="status-view low-risk"><span> {{nonResidentLevel?nonResidentLevel:"NA" | titlecase}}</span></span></div>
              </td>
          </tr>
          <tr>
              <td class="risk-factor">Residence Country is Sanctioned</td>
              <td class="risk-score">{{residenceCountryIsSanctionedScore?residenceCountryIsSanctionedScore: "NA"}}</td>
              <td class="text-center risk-level">
                  <div><span class="status-view low-risk"><span> {{residenceCountryIsSanctionedLevel?residenceCountryIsSanctionedLevel:"NA" | titlecase}}</span></span></div>
              </td>
          </tr>
          <!-- Add more rows as needed -->
          <tr class="b-table-bottom-row">
              <td class="risk-factor">Overall Rating</td>
              <td>{{overAllRating?overAllRating:"NA"}}</td>
              <td class="text-center risk-level">
                  <div><span class="status-view sanctioned-risk"><span> {{overAllRating?overAllRating:"NA"}}</span></span></div>
              </td>
          </tr>
      </tbody>
  </table>
</div>

       
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Score Breakdown</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
     <div ><ul ><li [attr.value]="nameScreeningHitsLength"><strong> Name Points : {{ scoreObjectRes['Name Points'] }} </strong>
        
    </li><li><strong> Father's Name Points : {{ scoreObjectRes['Father s Name Points'] }}</strong>
     
    </li><li><strong> Alias Score : {{ scoreObjectRes['Alias Score'] }}</strong>
        
    </li><li><strong> Country of Residence Points : {{ scoreObjectRes['Country of Residence Points'] }}</strong>
        
    </li><li><strong> ID Document Points : {{ scoreObjectRes['ID Document Points'] }}</strong>
        
    </li><li><strong> Date of Birth Points : {{ scoreObjectRes['Date of Birth Points'] }}</strong>
        
    </li><li><strong> Gender Points : {{ scoreObjectRes['Gender Points'] }}</strong>
        
    </li><li><strong> Nationality Points : {{ scoreObjectRes['Nationality Points'] }}</strong>

    </li><li><strong> Smart Search Points : {{ scoreObjectRes['Smart Search Points'] }}</strong>
        
    </li></ul>
  </div>
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-primary">Save Comments</button> -->
    <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>

<ng-template #cont let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Confirm</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body" style="height:108px">
     <p> Are you sure you want to initiate review process of this profile ?</p>
  </div>
  <div class="modal-footer">
   <button type="button" class="btn btn-primary" (click)="showInitiate(cont)">Yes</button>
    <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>

<ng-template #kycCont let-modal>
  <div class="modal-header">
    <h4 class="modal-title">KYC Status Review</h4>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body" style="height:300px">
     <div class="row mt-2">
        <div class="col-md-9">
           <h5  class="mb-2">Sanction</h5>
           <div class="input-group">
             <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
             <input type="text" class="form-control" value="Sanction" disabled>
             <span class="input-group-text" id="check-addon"><i [attr.class]="sanctionHitClass" [attr.style]="sanctionHitColor"></i></span>
           </div>
       </div>
       <div class="col-md-9">
        <h5  class="mb-2">PEP</h5>
         <div class="input-group">
           <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
           <input type="text" class="form-control" value="PEP" disabled>
           <span class="input-group-text" id="check-addon"><i [attr.class]="pepHitClass" [attr.style]="pepHitColor"></i></span>
         </div>
     </div>
     <div class="col-md-9">
        <h5  class="mb-2">Enforcement</h5>
       <div class="input-group">
         <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
         <input type="text" class="form-control" value="Enforcement" disabled>
         <span class="input-group-text" id="check-addon"><i [attr.class]="enforcementHitClass" [attr.style]="enforcementHitColor"></i></span>
       </div>
     </div>
     <div class="col-md-9">
        <h5  class="mb-2">Adverse Media</h5>
        <div class="input-group">
          <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
          <input type="text" class="form-control" value="Adverse Media"  disabled>
          <span class="input-group-text" id="check-addon"><i [attr.class]="adverseMediaHitClass" [attr.style]="adverseMediaHitColor"></i></span>
        </div>
    </div>
        <div class="col-md-9">
          <h5  class="mb-2">Risk Rating</h5>
          <div class="input-group">
            <span class="input-group-text" id="minus-addon"><i data-feather="minus-circle" class="feather icon-minus"></i></span>
            <input type="text" class="form-control" value="Risk Rating"  disabled>
            <span class="input-group-text" id="check-addon"><i [attr.class]="riskRatingHitClass" [attr.style]="riskRatingHitColor"></i></span>
          </div>
      </div>
      
</div>
     <div class="col-md-12"><label class="col-form-label mb-2">Status<i style="color: red;">*</i></label></div>
     <div class="col">
        <div class="custom-control custom-radio d-inline-block mr-3">
         <input type="radio" id="accepted" value="ACCEPTED" name="status" class="custom-control-input" [(ngModel)]="selectedStatus" >
            <label class="custom-control-label" for="accepted" style="margin-left: 5px;">Accepted</label>
        </div>
        <div class="custom-control custom-radio d-inline-block" style="margin-left: 5px;">
         <input type="radio" id="rejected" value="REJECTED" name="status" class="custom-control-input" [(ngModel)]="selectedStatus" >
            <label class="custom-control-label" for="rejected" style="margin-left: 5px;">Rejected</label>
        </div>
    </div>
 <div class="col-md-12"><label class="col-form-label">COMMENTS<i style="color: red;">*</i></label><textarea
                  type="text" [(ngModel)]="kycComment" pattern="^[a-zA-Z0-9]*$" maxlength="255" class="form-control" placeholder="" value=""></textarea>
                  <p>
                  Only 500 characters are allowed.
                  </p>
            </div>
  </div>
  <div class="modal-footer">
   <button type="button" class="btn btn-primary" (click)="submitKycReview()">Submit</button>
    <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>


<ng-template #keywordShow let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Keywords</h4>
  </div>
  <div class="modal-body">
     <div class="row d-flex">
        <div class="form-group col" *ngFor="let keyword of keywordList">
           <button type="button" class="btn btn-lg" id="tags" disabled>{{keyword}}</button>
        </div>
     </div>
     <!-- <div class="row mt-2 d-flex">
        <div class="form-control col">
           
           <button type="button" class="btn btn-lg" id="tags" disabled>Test333 2</button>
           <button type="button" class="btn btn-lg" id="tags" disabled>Testewdw 3</button>
           <button type="button" class="btn btn-lg" id="tags" disabled>Tesweeweret 1</button>
           <button type="button" class="btn btn-lg" id="tags" disabled>Test333 2</button>
           <button type="button" class="btn btn-lg" id="tags" disabled>Testewdw 3</button>
           <button type="button" class="btn btn-lg" id="tags" disabled>Tesweeweret 1</button>
           <button type="button" class="btn btn-lg" id="tags" disabled>Test333 2</button>
           <button type="button" class="btn btn-lg" id="tags" disabled>Testewdw 3</button>
        </div>
     </div> -->
  </div>
  <div class="modal-footer">
     <button type="button" class="btn btn-primary" (click)="modal.dismiss()">Close</button>
  </div>
</ng-template>

<app-modal #modalReportCustomer [modalConfig]="modalConfigReport" butt>
   <pdf-viewer 
       [src]="image"
       [rotation]="0"
       [original-size]="false"
       [show-all]="true"
       [fit-to-page]="false"
       [zoom]="1"
       [zoom-scale]="'page-width'"
       [stick-to-page]="false"
       [render-text]="true"
       [external-link-target]="'blank'"
       [autoresize]="true"
       [show-borders]="false"
       class="viewer">
 </pdf-viewer>
 </app-modal> 